import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import { CheckInContext } from "../../context/checkin";
import { UserContext } from "../../context/user";
import { getCDNImage } from "../../globals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Building } from "../../components/Icons";
import { invertDate, formatDate, formatDayMonth, roomData, reservationDisplayCode } from "../../functions";
import { T } from "react-translator-component";
import processHtml from "../../components/processHtml";

export default function CheckInHeader({ variant = "long" }) {
  const { data: checkIn, } = useContext(CheckInContext);
  const { language } = useContext(UserContext);

  const room = roomData(checkIn, language);

  return (<Row className={`text-left mx-1 ${variant !== "small" ? "mb-1" : ""}`}>
    <Col xs={12}>
      <div className="d-flex justify-content-between align-items-center" style={{ gap: 5, minWidth: 0 }}>
        <div>
          <div
            style={{
              width: variant === "small" ? 50 : 50,
              height: variant === "small" ? 50 : 50,
              borderRadius: 5,
              borderColor: "#AAA",
              borderWidth: 1,
              borderStyle: "solid",
              textAlign: "center",
              background: "#EEE",
              overflow: "hidden"
            }}
          >
            {checkIn.RoomCategory?.photo && (
              <img
                alt=""
                style={{
                  width: variant === "small" ? 50 : 50,
                  height: variant === "small" ? 50 : 50,
                  borderRadius: 5
                }}
                src={getCDNImage(checkIn.RoomCategory.photo)}
              />
            )}
            {!checkIn.RoomCategory?.photo && (
              <div style={{ marginTop: 10 }}>
                <Building width={30} height={30} color="#666666" />
              </div>
            )}
          </div>
          <div className="mb-0 px-1 text-center general-text-xs">
            {checkIn.RoomCategory?.m2 ? <b>{checkIn.RoomCategory.m2}m2.</b> : ""}{" "}
          </div>
        </div>
        <div className="flex-fill" style={{ minWidth: 0 }}>
          <p
            className="mb-0 px-1"
            style={{
              lineHeight: 1.5,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {room.name ?? checkIn.reservation?.unitGroup?.code + ". " + checkIn.reservation?.unitGroup?.name}
          </p>
          {variant !== "small" && (
            <>
              <p className="mb-0 px-1 general-text-xs text-truncate-3-lines">{processHtml(room.description)}</p>
            </>
          )}
        </div>
        <div className="pl-1" style={{ minWidth: 120, maxWidth: 120, borderLeft: "1px solid #EEE" }} >
          <p className="general-text-sm font-weight-bold text-center mt-1 mb-0">
            {reservationDisplayCode(checkIn)}
          </p>
          <p className="d-flex justify-content-center align-items-center general-text-sm text-center mt-1 mb-0">
            <FontAwesomeIcon
              icon={faCalendarAlt}
              className="text-muted"
              style={{ fontSize: "20px", margin: "5px" }}
            />{" "}
            <div className="px-1 text-center">
              {formatDayMonth(checkIn.reservation.arrival, T("general.short-dateformat"))}
              <br />
              {formatDayMonth(checkIn.reservation.departure, T("general.short-dateformat"))}
            </div>

          </p>
        </div>
      </div>
    </Col>
  </Row>);
}